import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/reevesdotnl/reevesdotnl/src/templates/pdf-view.tsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`CR26BAAE`}</h2>
    <p>{`Here are the most recent finite rotation poles for the main fragments in the Gondwana model, dated 2026 April 22. A supplement, dated 2026 June 11, defines the rotations of the three major and ten minor mid-ocean ridges around the Bouvet triple junction in Jurassic and (Early) Cretaceous time.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/reevesdotnl/edcb4436f7ecca25d0e184fb91c365ac/CR26BAAE-2e.pdf"
        }}>{`CR26BAAE rotations`}</a></li>
    </ul>
    <p>{`This model is illustrated graphically at key times in this document:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/reevesdotnl/da56032542700db68b3c8c39dd27731f/CR26BAAE-figures.pdf"
        }}>{`CR26BAAE figures`}</a></li>
    </ul>
    <p><em parentName="p">{`Last update: 2026 June 15`}</em></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../other-material"
        }}>{`Return to Global Thoughts page`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../../gondwana"
        }}>{`Return to Gondwana main page`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      